export const authConstant = {
  USER_LOGIN: "USER_LOGIN",
  USER_LOGOUT: "USER_LOGOUT",
  GET_CODE: "GET_CODE",
};

export const LoadConstant = "LOAD_STATUS";
